module.exports = __webpack_public_path__ + "img/kanBan.d0ed20bb.png";